/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import { connect } from "react-redux";
//table imports
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import Collapse from "@mui/material/Collapse";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../helper/currencyFormatter";
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import { Grid } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";

const ComponentBOM = (props) => {
  const { t } = props;
  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else {
      return "";
    }
  };
  const LineItem = (item) => {
    return (
      <TableContainer>
        <Table>
          <TableBody>
            {item.data
              .sort((a, b) =>
                a && b ? a.displaySequence - b.displaySequence : 0,
              )
              .map((child, childIndex) => (
                <React.Fragment key={childIndex}>
                  <TableRow>
                    <TableCell>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          size={{
                            xs: 4,
                          }}
                        >
                          <div style={{ display: "table-row" }}>
                            <div
                              style={{
                                width: item.level * 25,
                                display: "table-cell",
                              }}
                            ></div>
                            {props.mode === "offering" && (
                              <div
                                style={{
                                  display: "table-cell",
                                  width: "60px",
                                  paddingRight: "8px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <Tooltip title={t("CUSTOMER_VIEWABLE")}>
                                  <Checkbox
                                    color="primary"
                                    name="customerViewable"
                                    onChange={(event) => {
                                      item.changeBomProductsData(
                                        item.parent,
                                        child,
                                      );
                                    }}
                                    checked={child.customerViewable}
                                    disabled={
                                      item.disableChild ||
                                      item.isParentDisabled ||
                                      props.readonlyMode
                                    }
                                  />
                                </Tooltip>
                              </div>
                            )}
                            <div
                              style={{
                                display: "table-cell",
                                verticalAlign: "middle",
                              }}
                            >
                              {child.name}
                            </div>
                          </div>
                        </Grid>
                        <Grid
                          item
                          size={{
                            xs: 3,
                          }}
                        >
                          {child.description ? child.description : "-"}
                        </Grid>
                        <Grid
                          item
                          align="center"
                          size={{
                            xs: 2,
                          }}
                        >
                          {currencyFormatter(child.price)}{" "}
                          {child.priceType === "NTC" ? "NRC" : child.priceType}{" "}
                          {child.priceType === "NTC"
                            ? child.priceTenure > 1
                              ? "(" +
                                "per " +
                                child.priceTenure +
                                " " +
                                getPriceTenureUOM(child.priceTenureUOM) +
                                "s" +
                                ")"
                              : "(" +
                                "per " +
                                getPriceTenureUOM(child.priceTenureUOM) +
                                ")"
                            : ""}
                        </Grid>
                        <Grid
                          item
                          align="center"
                          size={{
                            xs: 1,
                          }}
                        >
                          {child.presetQuantity}
                        </Grid>
                        <Grid
                          item
                          align="right"
                          size={{
                            xs: 2,
                          }}
                        >
                          {child.featureCode}
                        </Grid>
                      </Grid>
                    </TableCell>
                    {/* <TableCell style={{ width: '60px' }}>
                                                <Tooltip title={t('CUSTOMER_VIEWABLE')}>
                                                    <Checkbox
                                                        color="primary"
                                                        name="customerViewable"
                                                        onChange={(event) => {
                                                            item.changeBomProductsData(item.parent, child);
                                                        }}
                                                        checked={child.customerViewable}
                                                        disabled={item.disableChild || item.isParentDisabled}
                                                    />
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell style={{ width: '30%', paddingLeft: '25px' }}>{child.name}</TableCell>
                                            <TableCell style={{ width: '30%' }}>{child.description ? child.description : '-'}</TableCell>
                                            <TableCell style={{ width: '10%' }} align='center'>
                                                {currencyFormatter(child.price)} {(child.priceType === 'NTC') ? 'NRC' : child.priceType} {child.priceType === 'NTC' ? '(' + child.priceTenure + ' ' + getPriceTenureUOM(child.priceTenureUOM) + ')' : ''}
                                            </TableCell>
                                            <TableCell style={{ width: '5%%' }} align='center'>{child.presetQuantity}</TableCell>
                                            <TableCell style={{ width: '15%' }} align='right'>{child.featureCode}</TableCell> */}
                    {/* <TableCell style={{ width: '5%', borderBottom: 0 }}></TableCell> */}
                  </TableRow>
                  {child.bom && child.bom.length > 0 && (
                    <LineItem
                      level={item.level + 1}
                      data={child.bom}
                      disableChild={item.disableChild}
                      isParentDisabled={
                        item.isParentDisabled
                          ? item.isParentDisabled
                          : !child.customerViewable
                      }
                      parent={item.parent}
                      changeBomProductsData={item.changeBomProductsData}
                      readonlyMode={props.readonlyMode}
                    />
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  return (
    <React.Fragment>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={props.expandVariants} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <TableContainer>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      {/* <TableCell align="left"></TableCell> */}
                      <TableCell>
                        <Grid container spacing={1} alignItems="center">
                          {/* <Grid item xs={1}><b>{t('CUSTOMER_VIEWABLE')}</b></Grid> */}
                          <Grid
                            item
                            size={{
                              xs: 4,
                            }}
                          >
                            <div style={{ display: "table-row" }}>
                              {props.mode === "offering" && (
                                <div
                                  style={{
                                    display: "table-cell",
                                    verticalAlign: "middle",
                                    width: "60px",
                                    paddingRight: "8px",
                                  }}
                                >
                                  <b>{t("CUSTOMER_VIEWABLE")}</b>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "table-cell",
                                  verticalAlign: "middle",
                                }}
                              >
                                <b>{t("NAME")}</b>
                              </div>
                            </div>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 3,
                            }}
                          >
                            <b>{t("DESCRIPTION")}</b>
                          </Grid>
                          <Grid
                            item
                            align="center"
                            size={{
                              xs: 2,
                            }}
                          >
                            <b>
                              {t("PRICE")}{" "}
                              {"(" + currencyFormatter("", false) + ")"}
                            </b>
                          </Grid>
                          <Grid
                            item
                            align="center"
                            size={{
                              xs: 1,
                            }}
                          >
                            <b>{t("QUANTITY")}</b>
                          </Grid>
                          <Grid
                            item
                            align="right"
                            size={{
                              xs: 2,
                            }}
                          >
                            <b>{t("PRODUCT_CODE")}</b>
                          </Grid>
                        </Grid>
                      </TableCell>
                      {/* <TableCell align="left" style={{ width: '60px' }}><b>{t('CUSTOMER_VIEWABLE')}</b></TableCell>
                                        <TableCell align="left"><b>{t('NAME')}</b></TableCell>
                                        <TableCell align="left" style={{ width: '30%' }}><b>{t('DESCRIPTION')}</b></TableCell>
                                        <TableCell align="center" style={{ width: '10%' }}><b>{t('PRICE')} {'(' + currencyFormatter('', false) + ')'}</b></TableCell>
                                        <TableCell align="center" style={{ width: '5%' }}><b>{t('QUANTITY')}</b></TableCell>
                                        <TableCell align="right" style={{ width: '15%' }}><b>{t('PRODUCT_CODE')}</b></TableCell> */}

                      {/* <TableCell align="center"><b>{t('ACTION')}</b></TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data.bom &&
                      props.data.bom.length > 0 &&
                      props.data.bom
                        .sort((a, b) =>
                          a && b ? a.displaySequence - b.displaySequence : 0,
                        )
                        .map(
                          (opt, componentIndex) =>
                            !opt.remove && (
                              <React.Fragment key={componentIndex}>
                                <TableRow
                                  style={{
                                    backgroundColor: !opt.expandKitComponents
                                      ? "#ffffff"
                                      : "#eee",
                                  }}
                                >
                                  <TableCell style={{ paddingRight: "10px" }}>
                                    <Grid
                                      container
                                      spacing={1}
                                      alignItems="center"
                                    >
                                      <Grid
                                        item
                                        size={{
                                          xs: 4,
                                        }}
                                      >
                                        <div style={{ display: "table-row" }}>
                                          {props.mode === "offering" && (
                                            <div
                                              style={{
                                                display: "table-cell",
                                                width: "60px",
                                                paddingRight: "8px",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              <Tooltip
                                                title={t("CUSTOMER_VIEWABLE")}
                                              >
                                                <Checkbox
                                                  color="primary"
                                                  name="customerViewable"
                                                  onChange={(event) => {
                                                    props.changeBomProductsData(
                                                      props.data.id,
                                                      opt,
                                                    );
                                                  }}
                                                  checked={opt.customerViewable}
                                                  disabled={
                                                    props.disableChild ||
                                                    props.readonlyMode
                                                  }
                                                />
                                              </Tooltip>
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              display: "table-cell",
                                              verticalAlign: "middle",
                                              paddingRight: "4px",
                                            }}
                                          >
                                            {opt.name}
                                          </div>
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        size={{
                                          xs: 3,
                                        }}
                                      >
                                        {opt.description}
                                      </Grid>
                                      <Grid
                                        item
                                        align="center"
                                        size={{
                                          xs: 2,
                                        }}
                                      >
                                        {currencyFormatter(opt.price)}{" "}
                                        {opt.priceType === "NTC"
                                          ? "NRC"
                                          : opt.priceType}{" "}
                                        {opt.priceType === "NTC"
                                          ? opt.priceTenure > 1
                                            ? "(" +
                                              "per " +
                                              opt.priceTenure +
                                              " " +
                                              getPriceTenureUOM(
                                                opt.priceTenureUOM,
                                              ) +
                                              "s" +
                                              ")"
                                            : "(" +
                                              "per " +
                                              getPriceTenureUOM(
                                                opt.priceTenureUOM,
                                              ) +
                                              ")"
                                          : ""}
                                      </Grid>
                                      <Grid
                                        item
                                        align="center"
                                        size={{
                                          xs: 1,
                                        }}
                                      >
                                        {opt.presetQuantity}
                                      </Grid>
                                      <Grid
                                        item
                                        align="right"
                                        size={{
                                          xs: 2,
                                        }}
                                      >
                                        {opt.featureCode}
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                  {/* <TableCell>
                                                    <Tooltip title={t('CUSTOMER_VIEWABLE')}>
                                                        <Checkbox
                                                            color="primary"
                                                            name="customerViewable"

                                                            onChange={(event) => {
                                                                props.changeBomProductsData(props.data.id, opt);
                                                            }}
                                                            checked={opt.customerViewable}
                                                            disabled={props.disableChild}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {opt.name}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {opt.description}
                                                </TableCell>
                                                <TableCell align='center'>{currencyFormatter(opt.price)} {opt.priceType === 'NTC' ? 'NRC' : opt.priceType} {opt.priceType === 'NTC' ? '(' + opt.priceTenure + ' ' + getPriceTenureUOM(opt.priceTenureUOM) + ')' : ''}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {opt.presetQuantity}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {opt.featureCode}
                                                </TableCell> */}
                                </TableRow>
                                {opt.bom && opt.bom.length > 0 && (
                                  <TableRow>
                                    <TableCell
                                      style={{ padding: "0px 0 0px 0px" }}
                                    >
                                      <Collapse
                                        in={true}
                                        timeout="auto"
                                        unmountOnExit
                                      >
                                        <LineItem
                                          data={opt.bom}
                                          level={1}
                                          disableChild={!opt.customerViewable}
                                          readonlyMode={props.readonlyMode}
                                          isParentDisabled={props.disableChild}
                                          parent={props.data.id}
                                          changeBomProductsData={
                                            props.changeBomProductsData
                                          }
                                          mode={props.mode}
                                        />
                                      </Collapse>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </React.Fragment>
                            ),
                        )}
                    {props.data.bom && props.data.bom.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          {t("NO_COMPONENTS_ADDED")}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            {/* <Button onClick={() => { this.addVariantRow() }} style={{ float: 'right', marginBottom: '5px' }} color="primary">Add Variant</Button> */}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //setErrorMessage: (errMsg, msgType) => dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ComponentBOM));
